(function () {
  if (window.__geekballsRelatedLoaded) return;
  window.__geekballsRelatedLoaded = true;

  function initLineageCarousel() {
    document.querySelectorAll('[data-lineage-track]').forEach(function (track) {
      var section = track.closest('.geekball-lineage-section');
      var prevBtn = section ? section.querySelector('[data-lineage-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-lineage-next]') : null;
      if (!prevBtn || !nextBtn) return;

      function updateArrows() {
        var overflowing = track.scrollWidth > track.clientWidth + 4;
        prevBtn.hidden = !overflowing;
        nextBtn.hidden = !overflowing;
      }

      function scrollStep() {
        var slot = track.querySelector('[data-lineage-card]');
        var width = slot ? slot.getBoundingClientRect().width : 200;
        return (width + 16) * 2;
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });

      updateArrows();
      window.addEventListener('resize', updateArrows);
    });
  }

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  // Reads from a hidden, never-mutated data source (real, fully rendered
  // native product cards) and (re)builds the visible grid by cloning 4 of
  // them at random every time. Keeping the source separate from the render
  // target means repeated inits (triggered by *any* section reloading in
  // the theme editor) never run out of data to rebuild from. Cloning the
  // actual <product-card> nodes (instead of rebuilding from data-*
  // attributes) preserves the theme's native hover/quick-add behaviour,
  // since custom elements re-run their connectedCallback when reinserted.
  function initHouseGrid() {
    document.querySelectorAll('[data-house-grid]').forEach(function (grid) {
      var section = grid.closest('.geekball-house-section');
      var source = section ? section.querySelector('[data-house-source]') : null;
      if (!source) return;

      var cards = Array.prototype.slice.call(source.querySelectorAll('[data-house-card]'));
      grid.innerHTML = '';

      shuffle(cards.slice()).slice(0, 4).forEach(function (c) {
        grid.appendChild(c.cloneNode(true));
      });
    });
  }

  // Same pattern as initHouseGrid, but for the sitewide "random products"
  // section: reads how many cards to show from data-random-count (set by
  // the section's max_products setting) instead of a hardcoded 4.
  function initRandomGrid() {
    document.querySelectorAll('[data-random-grid]').forEach(function (grid) {
      var section = grid.closest('.geekball-random-section');
      var source = section ? section.querySelector('[data-random-source]') : null;
      if (!source) return;

      var count = parseInt(grid.getAttribute('data-random-count'), 10);
      if (!count || count < 1) count = 4;

      var cards = Array.prototype.slice.call(source.querySelectorAll('[data-random-card]'));
      grid.innerHTML = '';

      shuffle(cards.slice()).slice(0, count).forEach(function (c) {
        grid.appendChild(c.cloneNode(true));
      });
    });
  }

  function initAll() {
    initLineageCarousel();
    initHouseGrid();
    initRandomGrid();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
